var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"คำสั่งซื้อ","link_back":"sell/orderretailcustomers"}}),_c('Pay_incorrect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }